<script lang="ts">
    export let collapseTargetId: string;
    export let isOpened = false;
</script>

<template>
    {#if isOpened}
        <button class="btn btn-default" type="button" data-toggle="collapse" data-target="#{collapseTargetId}" aria-expanded="false" on:click={() => isOpened = !isOpened}>
            <span class="glyphicon glyphicon-chevron-up"></span>
        </button>
    {:else }
        <button class="btn btn-default" type="button" data-toggle="collapse" data-target="#{collapseTargetId}" aria-expanded="false" on:click={() => isOpened = !isOpened}>
            <span class="glyphicon glyphicon-chevron-down"></span>
        </button>
    {/if}
</template>
